import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("cultiva_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const track = (name, meta = {}) => {
  api.post("/events", { name, meta }).catch(() => {});
};

export const WHATSAPP = "919623299614";
export const waLink = (msg = "Hello Cultiva Botanics, I'd like to know more.") =>
  `https://wa.me/${WHATSAPP}?text=${encodeURIComponent(msg)}`;

export const LOGO = "https://customer-assets-eiarnc6j.emergentagent.net/job_eager-kalam-16/artifacts/iemabj73_Brand%20Logo.jpg";
export const GROUP_IMG = "https://customer-assets-lqy194kg.emergentagent.net/job_4fc941ff-ab77-44f7-879a-f53a420285d2/artifacts/skzwsbp4_Group%20products.png";

export const TEXTURES = {
  leaf: "https://images.unsplash.com/photo-1586073305502-5c5cc4a594bd",
  botanical: "https://images.pexels.com/photos/31968576/pexels-photo-31968576.jpeg",
  shipping: "https://images.pexels.com/photos/262353/pexels-photo-262353.jpeg",
};

export function apiErr(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail?.msg || detail);
}
